import Vue from 'vue';
import { updateField } from 'vuex-map-fields';
import { uniq } from 'lodash';

export default {
  ADD_CONVERSATION_ACTIVITY(state, payload) {
    state.addConversationActivity = payload;
  },
  /** TODO during rewrite this can replace the above add_conversation_activity since those are all messages */
  ADD_MESSAGE_TO_LIST(state, payload) {
    state.addMessage = payload;
  },
  REMOVE_MESSAGE_FROM_LIST(state, messageSid) {
    state.removeMessage = messageSid;
  },
  REVERT_CONVERSATION_ACTIVITY(state, payload) {
    state.removeConversationActivity = payload;
  },
  SET_CONVERSATIONS(state, payload) {
    state.conversationList = payload;
    if (payload.meta && payload.meta.current_page === 1) {
      state.allConversationsList = [...payload.data];
    } else {
      state.allConversationsList = [...state.allConversationsList, ...payload.data];
    }
  },
  CONVERSATIONS_LOAD(state, payload) {
    state.conversationsLoad = payload;
  },
  SET_MESSAGES(state, payload) {
    state.messageList = { ...payload };
  },
  MESSAGES_LOADED(state, payload) {
    state.messagesLoaded = payload;
  },
  CLEAR_MESSAGE_LIST_META(state) {
    state.messageList.meta = {};
  },
  SET_QUICK_REPLIES(state, payload) {
    state.quickReplyList = payload;
  },
  QUICK_REPLIES_LOADED(state, payload) {
    state.quickRepliesLoaded = payload;
  },
  SET_STATISTICS(state, payload) {
    // state.statistics = payload;
    Vue.set(state.statistics, payload.merchant_id, payload.data);
  },
  SET_ACTIVE_CONVERSATION(state, payload) {
    state.activeConversation = payload;
  },
  EDIT_ACTIVE_CONVERSATION_DATA(state, payload) {
    Object.keys(payload).forEach((key) => {
      state.activeConversation[key] = payload[key];
    });
    state.activeConversation.ignore = true;
    state.activeConversation = { ...state.activeConversation };
  },
  SET_CURRENT_CONVERSATION_INBOUND(state, payload) {
    state.activeConversation.last_message = payload.message.body;
    state.activeConversation.message_sent_at = payload.message.timestamp;
    state.activeConversation.direction = payload.message.direction;
  },
  UPDATE_CONVERSATION_ASSIGNED_TO(state, { conversationId, memberId }) {
    // update active conversation if conversationId matches
    if (state.activeConversation && state.activeConversation.id === conversationId) {
      console.info('updating activeConversation user_id');
      state.activeConversation.user_id = memberId;
    }
  },
  SET_MESSAGE_REF(state, payload) {
    state.messageSent = { ...payload, ref: true };
  },
  CONVERSATION_MESSAGE_SENT(state, payload) {
    state.messageSent = payload;
    const conversation = state.chatFastReload[payload.conversation_id];
    if (conversation) {
      const message = conversation.data.find(message => message.sid === payload.temp_sid);
      if (message) {
        message.sid = payload.sid;
        message.id = payload.sid;
        if (!payload.ref) {
          message.status = 'sent';
        }
      }
    }
  },
  ADD_MESSAGE(state, payload) {
    state.messageList.data.unshift(payload.outboundData);
    if (state.chatFastReload[payload.conversationId]) {
      state.chatFastReload[payload.conversationId].data.unshift(payload.outboundData);
    }
    if (state.messageCountChange > 100) {
      state.messageCountChange = 0;
    } else {
      state.messageCountChange++;
    }
  },
  CLEAR_FAST_RELOAD(state) {
    state.chatFastReload = {};
  },
  RELOAD_FIRST_PAGE(state) {
    state.reloadFirstPage++;
  },
  CONVERSATION_REASSIGNED(state, payload) {
    state.reassignedConversation = payload;
  },
  CONVERSATION_FOLDER_CHANGED(state, payload) {
    state.folderChanged = payload;
  },
  CONVERSATION_SEEN(state, payload) {
    state.conversationSeen = payload;
  },
  UNREAD_CONVERSATIONS_COUNT(state, payload) {
    Vue.set(state.unreadConversationsCount, payload.merchant_id, payload.unread_conversations);
    // state.unreadConversationsCount = payload;
  },
  SENT_MESSAGE_STATUS_CHANGED(state, payload) {
    state.sentMessageStatus = payload;
  },
  BOT_STATUS_UPDATED(state, payload) {
    state.botStatusUpdated = payload;
  },
  QUICK_REPLY_CREATED(state, payload) {
    state.quickReplyList.push(payload);
    state.quickReplyList = [...state.quickReplyList.sort((a, b) => (b.keyword.toUpperCase() < a.keyword.toUpperCase() ? 1 : (b.keyword.toUpperCase() > a.keyword.toUpperCase() ? -1 : 0)))];
  },
  QUICK_REPLY_UPDATED(state, payload) {
    const targetQuickReply = state.quickReplyList.find(qr => qr.id === payload.id);
    targetQuickReply.keyword = payload.keyword;
    targetQuickReply.text = payload.text;
    state.quickReplyList = [...state.quickReplyList.sort((a, b) => (b.keyword.toUpperCase() < a.keyword.toUpperCase() ? 1 : (b.keyword.toUpperCase() > a.keyword.toUpperCase() ? -1 : 0)))];
  },
  QUICK_REPLY_DELETED(state, qrId) {
    state.quickReplyDeleted = qrId;
    state.quickReplyList = state.quickReplyList.filter(qr => qr.id !== qrId);
  },
  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = { ...payload };
    }
  },
  FILE_UPLOAD_ERROR(state, payload) {
    state.fileUploadError = payload;
  },
  CLEAR_CHAT_DATA(state) {
    state.conversationList = [];
    state.messageList = {
      data: [],
      meta: {
        next_messages_before: null,
      },
    };
    state.chatFastReload = {};
    state.messagesLoaded = false;
  },
  SAVE_FIRST_PAGE_OF_MESSAGES(state, payload) {
    state.chatFastReload[payload.conversationId] = payload.messageList;
  },
  SAVE_FIRST_PAGE_OF_CONVERSATIONS(state, payload) {
    const numberId = payload.numberId || 'my';
    if (!state.conversationFastReload[numberId]) {
      // temp_remove state.conversationFastReload[numberId] = {};
    }
    // temp_remove state.conversationFastReload[numberId][payload.folder] = payload.data;
  },
  UPDATE_FIRST_PAGE_OF_CONVERSATIONS(state, payload) {
    if (!state.conversationFastReload[payload.numberId]) {
      // temp_remove state.conversationFastReload[payload.numberId] = {};
    }
    // temp_remove state.conversationFastReload[payload.numberId][payload.folder] = payload.data;
  },
  CLEAR_CONVERSATION_CACHE(state) {
    // temp_remove state.conversationFastReload = {};
  },
  ADD_MESSAGE_TO_CHAT_FAST_LOAD(state, payload) {
    if (!state.chatFastReload[payload.conversation_uid]) {
      return;
    }
    const messageData = payload.message || payload.activity;
    if (
      (payload.message && !state.chatFastReload[payload.conversation_uid].data.some(m => m.sid === payload.message.sid)) ||
      (
        payload.activity &&
        payload.activity.meta_data &&
        payload.activity.meta_data.new_folder &&
        state.chatFastReload[payload.conversation_uid].data &&
        state.chatFastReload[payload.conversation_uid].data[0] &&
        state.chatFastReload[payload.conversation_uid].data[0].meta_data &&
        state.chatFastReload[payload.conversation_uid].data[0].meta_data.new_folder &&
        payload.activity.meta_data.new_folder !== state.chatFastReload[payload.conversation_uid].data[0].meta_data.new_folder
      ) ||
      (
        payload.activity &&
        state.chatFastReload[payload.conversation_uid].data &&
        state.chatFastReload[payload.conversation_uid].data[0] &&
        state.chatFastReload[payload.conversation_uid].data[0].direction !== 'activity'
      )
    ) {
      state.chatFastReload[payload.conversation_uid].data.unshift(messageData);
      state.chatFastReload[payload.conversation_uid].data = uniq(state.chatFastReload[payload.conversation_uid].data, 'sid');
      if (state.chatFastReload[payload.conversation_uid].data.length > 50) {
        state.chatFastReload[payload.conversation_uid].data.length = 50;
      }
    }
  },
  REMOVE_CONVERSATION_FROM_CHAT_FAST_LOAD(state, payload) {
    delete state.chatFastReload[payload.conversationId];
  },
  REMOVE_MESSAGE_FROM_CHAT_FAST_LOAD(state, payload) {
    const filteredMessages = state.chatFastReload[payload.conversationId].data.filter(message => !message.temp_sid || message.temp_sid !== payload.outboundData.temp_sid);
    state.chatFastReload[payload.conversationId].data = [...filteredMessages];
  },
  SET_BOT_STATUS_FOR_ACTIVE_CONVERSATION(state, payload) {
    state.activeConversation.bot_active = payload.data.bot_active;
    state.botStateChange = payload;
  },
  SET_CONVERSATION_SEEN_FOR_ACTIVE_CONVERSATION(state, status) {
    state.activeConversation.seen = status;
    state.activeConversation.assignment_seen = status;
    state.activeConversation.message_unseen_count = 0;
  },
  MESSAGES_LOADING(state, status) {
    state.messagesLoading = status;
  },
  ADD_CONVERSATION_TO_TOP(state, conversation) {
    state.conversationList.data.unshift(conversation);
  },
  SET_SEARCH_ALL_NUMBERS_BUTTON(state, status) {
    state.chatSearchAllNumbersSelected = status;
  },
  UPDATE_CONVERSATION_CONTACT(state, payload) {
    if (state.conversationList && state.conversationList.data) {
      const targetConversation = state.conversationList.data.find(conversation => conversation.contact.id === payload.id);
      if (targetConversation) {
        targetConversation.contact.name = payload.name;
      }
    }
  },
  REMOVE_BLOCKED_FLAG_FROM_CONVERSATION(state, conversationId) {
    if (state.conversationList && state.conversationList.data) {
      const targetConversation = state.conversationList.data.find(conversation => conversation.id === conversationId);
      if (targetConversation) {
        targetConversation.blocked = false;
      }
    }
  },
  REMOVE_CONVERSATION_FROM_LIST(state, conversation) {
    const targetConversationIndex = state.conversationList.data.findIndex(c => c.id === conversation.id);
    state.conversationList.data.splice(targetConversationIndex, 1);
    state.conversationList = { ...state.conversationList };
  },
  SET_START_NEW_CONVERSATION_SELECT_ID(state, id) {
    state.startNewConversationSelectId = id;
  },
  START_CONVERSATION_WITH(state, number) {
    state.startConversationNumber = number;
  },
  ADD_NEW_TEMP_CONVERSATION(state, conversation) {
    state.tempConversations = [...state.tempConversations, conversation];
  },
  REMOVE_NEW_TEMP_CONVERSATION(state, conversation) {
    const conversationIndex = state.tempConversations.findIndex(c => conversation.id === c.id);
    state.tempConversations.splice(conversationIndex, 1);
    state.tempConversations = [...state.tempConversations];
  },
  SET_ALLOW_ENTER(state, status) {
    state.allowEnter = status;
  },
  ENTER_PRESSED(state) {
    state.enterPressed = ++state.enterPressed;
  },
  SET_FOLDER(state, folder) {
    state.folder = folder;
  },
  SET_SHOW_EMPTY_DONE(state, status) {
    state.showEmptyDone = status;
  },
  SET_SHOW_EMPTY_OPEN(state, payload) {
    state.showEmptyOpen = payload.status;
    state.showEmptyFresh = payload.fresh;
  },
  FORCE_CONVERSATION_LOAD_SPINNER(state, status) {
    state.forceConversationLoadSpinner = status;
  },
  RESET_CONVERSATION_LIST(state, flag) {
    state.resetConversationListFlag = flag;
  },
  SET_CONSENT(state, payload) {
    if (state.activeConversation && state.activeConversation.contact && state.activeConversation.id === payload.conversation_uid) {
      state.activeConversation.contact.has_messaging_consent = payload.consent;
    }
  },
  UPDATE_INPUT_MESSAGE(state, message) {
    state.inputMessageText = message;
  },
  CLEAR_INPUT_MESSAGE(state) {
    state.inputMessageText = null;
  },
  UPDATE_CONVERSATIONS(state, payload) {
    state.updateConversations = payload;
  },
  BACKUP_OUTBOUND_MESSAGE(state, payload) {
    state.inputBackup[payload.oldConversationId] = payload.messageContent;
  },
  CLEAR_OUTBOUND_MESSAGE(state, conversationId) {
    delete state.inputBackup[conversationId];
  },
  EMOJI_REACTION_RECEIVED(state, payload) {
    state.pusherEmojiReactionReceived = payload;
  },
  ADD_REACTION_TO_CHAT_FAST_LOAD(state, payload) {
    if (!state.chatFastReload[payload.conversationId]) {
      return;
    }
    const targetMessage = state.chatFastReload[payload.conversationId].data.find(m => m.id === payload.message_id);
    if (targetMessage) {
      if (!targetMessage.reaction) {
        targetMessage.reaction = [];
      }

      if (payload.sender.name === 'contact') {
        targetMessage.reaction = targetMessage.reaction.filter(r => r.sender.name !== 'contact');
      } else {
        targetMessage.reaction = targetMessage.reaction.filter(r => r.sender.name === 'contact');
      }
      if (payload.emoji) { // This prevents empty emoji from poping up as empty bubble. Empty emoji means someone deleted its reaction.
        targetMessage.reaction.push({
          sender: {
            id: payload.sender.id,
            name: payload.sender.name,
          },
          emoji: payload.emoji,
        });
      }
    }
  },
  ACTIVE_CONVERSATION_READ_UPDATE(state, payload) {
    if (state.activeConversation && state.activeConversation.id === payload.conversation.id) {
      state.activeConversation.assignment_seen = payload.conversation.assignment_seen;
      state.activeConversation.seen = payload.conversation.assignment_seen;
    }
  },
  updateField,
};
